var MpPageUnique;

(function() {
    if (!document.querySelector('#vue-unique')) {
        return;
    }

    MpPageUnique = new Vue({
        el: '#vue-unique',
        mixins: [MpSessionLogin],
        data: {
            isInitialized: false,
            initialized: false,
        },
        computed: {

            dataSend: function() {
                return Serializer.serialize({
                    'login_unique': 1,
                    'login_user': this.user,
                    'login_passwd': this.passwd,
                });
            },
        },
        methods:{

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
                this.$nextTick(function() {
                    this.$refs.user.focus();
                });
            },
        },
        filters: {},
        mounted: function() {
            this.init();
        },
        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        }
    });

})();
